var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0, 0, 0, 0.5)",
    fillRule: "nonzero",
    transform: "translate(-1 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 28v-7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v7H5a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6zm3-9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2zM6 19a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.352 14.461v-.247a2 2 0 0 1 .935-1.693L13.44 5.503a2 2 0 0 1 2.135.004l11.066 7.013a2 2 0 0 1 .93 1.69v.251c0 .747-.606 1.352-1.353 1.352H2.704a1.352 1.352 0 0 1-1.352-1.352z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    x: 19,
    y: 6,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.d9edeaa91f9c19ffaec7ea1b4c3288ee.svg";
export { ForwardRef as ReactComponent };